var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout wrap widgets" },
    _vm._l(_vm.listaAlertasWidgets, function(l) {
      return _c(
        "v-flex",
        {
          key: l.tipo_alarma,
          class: l.id,
          attrs: { m1: "", md1: "", "wrapper-widget": "" },
          on: {
            click: function($event) {
              return _vm.filterWidget(l.id)
            }
          }
        },
        [
          _c("p", { staticClass: "title-widget" }, [
            _vm._v(_vm._s(_vm.filterAlert(l.tipo_alarma)))
          ]),
          _c("p", { staticClass: "count" }, [_vm._v(_vm._s(l.total))])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }